module.exports = __webpack_public_path__ + "static/media/animal-cognition.427752c8.svg";